import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import React from 'react';
const CostFormatter = _ref => {
  let {
    object,
    keyName,
    disabled
  } = _ref;
  return /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    type: "text",
    disabled: disabled,
    object: object,
    name: keyName,
    decimalScale: 2
  });
};
export default CostFormatter;